import { createContext } from 'react';
import { TRegistrationContextType } from '@common/modals/register/context/index';


export const RegistrationContext = createContext<TRegistrationContextType>({} as TRegistrationContextType);


export default RegistrationContext;